import { ReactNode } from 'react';
import { Event } from '@blisspointmedia/bpm-types/dist/OracleActivity';
import { AppFieldOf, TextField } from '@Components/Forms/FormField';
import { formatDayMonth } from '@src/utils/date-utils';
import { EventFormEditor } from './useEditEventForm';

interface DetailTitleBlockProps {
  event: Event;
  editor?: EventFormEditor;
}

export const DetailTitleBlock = ({ event, editor }: DetailTitleBlockProps): ReactNode => {
  const { title, date, lastEditedAt, lastEditedBy } = event;
  return (
    <div className='activity-feed-detail-title-block'>
      {editor ? (
        <TitleField editor={editor} />
      ) : (
        <h1 className='activity-feed-detail-title'>{title}</h1>
      )}
      <div className='activity-feed-detail-meta'>
        <span>Created {formatDayMonth(date)} by the Oracle</span>
        {lastEditedAt && lastEditedBy && (
          <>
            <span className='activity-feed-detail-meta-dot'>·</span>
            <span>
              Last edited {formatDayMonth(lastEditedAt)} by {lastEditedBy}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

interface TitleFieldProps {
  editor: EventFormEditor;
}

const TitleField = ({ editor: { form, disabled } }: TitleFieldProps): ReactNode => (
  <AppFieldOf
    form={form}
    name='title'
    field={TextField}
    fieldProps={{
      label: 'Title',
      required: true,
      fieldClassName: 'activity-feed-detail-field',
      labelClassName: 'activity-feed-detail-field-label',
      disabled
    }}
  />
);
